const variablesConexionBack = {
  linkBackend: process.env.REACT_APP_API_URL
    || (process.env.NODE_ENV === 'development' ? 'http://localhost:3001/api' : '/api'),
};

export default variablesConexionBack;
